<template>
  <div class="Vlt-template Vlt-template--sidenav">
    <sidebar v-if="isLoggedIn && isAdmin && isAdminLayout" :logout="logout"></sidebar>
    <main class="Vlt-main Vlt-main--dark mainAdminContainer" ref="mainContainer">
      <section>
        <router-view></router-view>
      </section>
    </main>
  </div>
</template>

<script>
import {
  VltIcon,
  VltButton,
} from '@vonagevolta/vue';
import { mapGetters } from 'vuex';
import Sidebar from '../components/Sidebar.vue';

export default {
  name: 'Dashboard',
  components: {
    VltIcon,
    VltButton,
    Sidebar,
  },
  props: {
    logout: {
      type: Function,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
        isLoggedIn: 'isLoggedIn',
        isAdmin: 'isAdmin',
        isAdminLayout: 'getIsAdminLayout',
    }),
  },
    watch: {
      isAdminLayout(current) {
      }
    },
};
</script>

<style lang="scss" scoped>
  .app-main {
    flex: 1;
    //height: 100vh;
    overflow: hidden;
    padding: 15px 20px 20px 10px;
    //height: calc(100vh - 70px);
  }

  .flexContainer {
    display: flex;
    align-items: stretch
  }

  .linkImg {
    width: 130px;
  }

  .Vlt-margin--left1 {
    margin-left: 10px;
  }

  .Vlt-margin--left2 {
    margin-left: 20px;
  }

  .stretch-height {
    height: 100%;
  }

  .Vlt-template {
    margin-top: 20px;
  }
.mainAdminContainer {
  height: 82vh;
}
.Vlt-main {
  overflow: scroll;
  overflow-x: hidden;
}
.Vlt-main::-webkit-scrollbar {
  width: 0px; /* remove scrollbar space */
}
.Vlt-template {
  margin: 0;
}

</style>
